// NG 2
import { Injectable, OnInit } from '@angular/core';
import { Http, Response, Headers, RequestOptions} from '@angular/http';
//import { LocalStorageService } from 'angular-2-local-storage';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

// APP
import { BaseService } from './base.service';
import { AppConfig } from '../app.config';

@Injectable()
export class AuthenticationService extends BaseService {
    _baseUrl = AppConfig.config.defaultServicePath;
    _baseCpuiUrl: string = AppConfig.config.baseCPUIUrl;    

    constructor(private http: Http) {
        super();
    }

    getLoginInfo() {

        let headers = new Headers();
        headers.append('Content-Type', 'application/json');

        return this.http.post(this._baseCpuiUrl + 'GetLoginInfo', JSON.parse(JSON.stringify({ isSessionActive: '' } || null)), this.addHeader())
            .map(res => {

                if (res.status === 200) {
                    let body = JSON.parse(res.text());
                    if (body != null && body.d != null && body.d.LoginUserInfo != null) {
                        // set the loggedinUser info when login success
                        sessionStorage.setItem('loggedInUser', JSON.stringify(body.d.LoginUserInfo));
                        return body;
                    }
                    else if (body != null && body.d != null && (body.d.LoginStatus == "Logout" || body.d.LoginStatus == "ServerError")) {
                        this.logout();
                    }
                    else {
                        return Observable.throw(body.message);
                    }
                }
            })
            .catch(this.errorHandler);
    }

    getTokenDetail(token) {
        return this.http.get(this._baseUrl + 'MIHUser/GetTokenDetail', this.addHeader())
            .map(res => res.json())
            .catch(this.errorHandler);
    }

    getUserDetail(model) {
        return this.http.post(this._baseCpuiUrl + 'GetUowId', JSON.parse(JSON.stringify(model)))
            .map(res => res.json())
            .catch(this.errorHandler);
    }
    //getHeaderHTML() {
    //    let headers = new Headers();
    //    headers.append('Content-Type', 'application/json');

    //    return this.http.post(this._baseCpuiUrl + 'GetHeaderHTML', JSON.parse(JSON.stringify({ appName: 'HPD Mandatory Inclusionary Housing' } || null)))
    //        .map(res => res.json())
    //        .catch(this.errorHandler);
    //}

    getUpdateProfileUrl() {
        return this.http.post(this._baseCpuiUrl + 'GetUpdateProfileUrl', null, this.addHeader())
            .map(res => res.json())
            .catch(this.errorHandler);
    }

    getUpdateProfile() {       
        return this.http.post(this._baseCpuiUrl + 'UpdateProfile', null, this.addHeader())
            .map(res => res.json())
            .catch(this.errorHandler);
    }

    logout() {
        sessionStorage.clear();
        window.location.href = './';
    }

    isLoggedIn() {
        let isTrur: boolean = false;
        if (sessionStorage.getItem("loggedInUser") != null)
            isTrur = true;

        return isTrur;
    }
    
    getUser() {

        let user = sessionStorage.getItem('loggedInUser');
        if (user != null)
            return JSON.parse(user);
        else
            return null;
    }
}